import Swal from "sweetalert2";
import { const_routes } from "../helpers/const_routes";
import { fetchToken } from "../helpers/fetch";
import { types } from "../types/types";
import { t } from "i18next";
import { startLogout } from "./authActions";
import { debugLogActions } from "../helpers/debugHelper";

export const startLoadingCountriesByRegionId = (region_id) => {
  
  return async (dispatch) => {
    const resp = await fetchToken(
      `${const_routes.SCHEMA}`,
      `${const_routes.VERSIONV1}`,
      `${const_routes.ROUTE_COUNTRY}`,
      `getByRegionId/${region_id}`
    );
    const body = await resp.json();

    if (body.ok) {
      dispatch(loadingCountries(body.countries));
    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

export const startLoadingCountriesByRegionIdLocal = (region_id) => {
  
  return async (dispatch, getState) => {

    const state = getState();
    const { listFullCountries } = state.locationCountry;

    let countries = [];
    listFullCountries.forEach((country) => {
      if(country.region_id === region_id) {
        countries.push(country);
      }
    })

    dispatch(loadingCountries(countries));
    
  };
};

const loadingCountries = (countries) => ({
  type: types.LOCATIONCOUNTRY_START_LOADING_COUNTRY,
  payload: countries,
});

export const getContinentRegionCountryByCountryId = (catalogcountries_id) => {
  
  return async (dispatch) => {
    const resp = await fetchToken(
      `${const_routes.SCHEMA}`,
      `${const_routes.VERSIONV1}`,
      `${const_routes.ROUTE_COUNTRY}`,
      `getContinentRegionCountry/${catalogcountries_id}`
    );
    const body = await resp.json();

    if (body.ok) {
      dispatch(setCountrySelectedInitial(body.country));
      dispatch(setRegionSelectedInitial(body.region));
      dispatch(setContinentSelectedInitial(body.continent));

    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

const setCountrySelectedInitial = (country) => ({
  type: types.LOCATIONCOUNTRY_SELECT_COUNTRY_INITIAL,
  payload: country,
});

const setRegionSelectedInitial = (region) => ({
  type: types.LOCATIONCOUNTRY_SELECT_REGION_INITIAL,
  payload: region,
});

const setContinentSelectedInitial = (continent) => ({
  type: types.LOCATIONCOUNTRY_SELECT_CONTINENT_INITIAL,
  payload: continent,
});

export const selectCountry = (country) => ({
  type: types.LOCATIONCOUNTRY_SELECT_COUNTRY,
  payload: country,
});

export const cleanCountry = () => ({
  type: types.LOCATIONCOUNTRY_CLEAN_COUNTRY,
});

export const startLoadingCountries = () => {
  return async (dispatch) => {
    const resp = await fetchToken(`${const_routes.SCHEMA}`, `${const_routes.VERSIONV1}`, `${const_routes.ROUTE_COUNTRY}`, `get`);
    const body = await resp.json();

    debugLogActions(':: countryActions, startLoadingCountries', { 'body': body });

    if (body.ok) {
      dispatch(loadingCountriesAll(body.countrys));
    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

const loadingCountriesAll = (countries) => ({
  type: types.LOCATIONCOUNTRY_START_LOADING_COUNTRY_ALL,
  payload: countries,
});

export const loadingLocationCountryFilter = (catalogs) => ({
  type: types.LOCATIONCOUNTRY_START_LOADING_FILTER,
  payload: catalogs,
});